module.exports = __webpack_public_path__ + "img/loading.dd5181e1.svg";